import {
  IonImg,
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonRow,
  IonCol,
  IonLabel,
  IonItemDivider,
  IonText
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import {
  IONICWrapper,
  isMobile,
  isEntitled,
  SourceTMSValidation,
} from "../../../utils/common";
import "./LoadTileRight.scss";
import {
  ASSIGN_DRIVER_CTA_TEXT,
  EXECUTIONSTATUS,
  MODULES,
  WEB_PAYMENT_LINK,
  Roles,
  UN_ASSIGN_DRIVER_CTA_TEXT,
  BOOK_LOAD_CTA_TEXT,
  DEFAULT_BUTTON_COLOR,
  radioButtonData,
  SUBMIT_INVOICE,
  CREATE_INVOICE,
  SUBMIT_INVOICE_MESSAGE,
  MYLOAD_DOCUMENT_UPLOAD,
  ESOURCE_TYPE_CHECK,
  GET_QUALIFIED_BUTTON_NAME,
  MY_LOAD,
  invoice_validation_modal_title,
  invoice_validation_modal_message,
  declined_load_modal_title,
  declined_load_modal_message,
  DECLINE_ACTION_TYPE,
  DECLINE_ACTION_QUALIFIER,
  TENDER_DECLINE_SUCCESS_MESSAGE,
  CONTACT_US_TEXT,
  MyLoadsConfigFallback,
  ENTER_INVOICE_ID_HEADER,
  CARRIER_PRO_ID_HEADER,
  REASON_CODES,
  VIEW_LOAD_CTA_TEXT,
  CONTACT_DETAILS_NOT_FOUND
} from "../../../utils/constants";
import React, { useEffect, useState } from "react";
import { getSessionId, logEvent } from "../../../utils/Analytics";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { LoadStopModel } from "../../../components/app/ShipmentUpdateScreen/loadStopUtil";
import i18n from "i18n";
import styled from "styled-components";
import { getFormatRoles } from "../../../utils/formatData";
import "../../../components/shared/Documents/DocumentsDialog.scss";
import { useDispatch, useSelector } from "react-redux";
import { contactUsDetailsRequest, createInvoice, submitInvoiceNew } from "../../../actions/myload/action";
import { ToastMessage } from "../../../utils/ToastMessage";
import InvoiceRadioContainer from "../../../containers/ExecuteContainer/InvoiceContainer/Utils/InvoiceRadioContainer";
import {
  validateDocumentContent,
  toBase64,
  getPayLoadShipmentId,
  getSourceSystemDetails,
  payloadCreationForDocUpload
} from "../../../components/shared/Documents/utils";
import { UploadDocumentModel } from "../../../models/myLoad/uploadDocument.model";
import { MyLoad } from "../../../models/myLoad/myLoad";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import { UploadDocument } from "../../../components/shared/Documents/UploadDocument";
import { SearchById } from "../../../models/home/SearchLoadByReferenceId.model";
import { getUserMasterData } from "../../../selectors/selector";
import { notValidTrailer } from "../../../components/app/ShipmentUpdateScreen/ShipmentUpdate.Util";
import { setNavigation } from "../../../actions/App/action";
import { IUserDetails } from "../../../schemas/user";
import { TenderAction } from "../../../models/myLoad/tenderAction.model";
import { tenderAction } from "../../../actions/carrierTendered/action";
import { getCurrentDatewithTimeZone, getCustomer } from "../../../pages/LoadDetails/loadDetailsUtil";
import { fetchShipments } from "../../../actions/carrierAssign/action";
import { DeclineDropDown } from "../../../components/shared/carrierTenderedDropDown/DeclineDropdown";
import { store } from "../../../store";
import { isDispatcherRole } from "../../../utils/roleUtil/RoleUtil";
import { loadTileButtonVisibility, declineReasonDropDownVisibility, isCarrierProVisible, isInvoiceInputFieldVisible } from "../../../utils/sourceTMSAndDivisionFilter";
import { FetchFromMyLoadConfig } from "../../../utils/MyLoads.util";
import { buyLoadShipmentRequest } from "../../../actions/BookLoad/action";
import { GetShipment } from "../../../models/home/GetShipment.model";
import { IEShipmentCostItem, IEShipmentResponse } from "../../../schemas/getShipment/GetShipment.schema";
import { getShipmentDetails } from "../../../selectors/Myload/selector";
import { useHistory } from "react-router";
import ContactUsModal from "app/components/shared/ContactUsModal/ContactUsModal";


const CustomButton = styled(IonButton)`
  --background: ${(props: any) => 
    props["data-test"].split("_")[1] &&
    isDispatcherRole() &&
    props["data-test"].split("_")[0] === BOOK_LOAD_CTA_TEXT
      ? props["data-test"].split("_")[1]
      : DEFAULT_BUTTON_COLOR};
`;

const LoadTileRight = (props: any) => {
  const {
    loadId,
    load,
    isWatched = false,
    toggleWatchLoad = ({ ...args }) => {}
  } = props;
  const history = useHistory();
  const currencyFormatterRate = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: (props.load && props.load.costCurrency) || "USD",
    minimumFractionDigits: 2
  });
  const [isClicked, setOnClick] = useState<boolean>(false);
  const [showButton, setShowButton] = useState<boolean>(false);
  const [buttonName, setButtonName] = useState(UN_ASSIGN_DRIVER_CTA_TEXT);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState<any[]>([]);
  const [invoiceValidationModal, setinvoiceValidationModal] = useState<any>({
    isModalOpen: false,
  });
  const [showModalforDeclineLoad, setShowModalforDeclineLoad] = useState<boolean>(false);
  const [declineReasonCode,setDeclineReasonCode] = useState<string>("");
  const [payloadReasonCode, setPayloadReasonCode] = useState<string>("");  
  const { t } = useTranslation();
  const updateduserDetails : IUserDetails = useSelector(getUserMasterData());
  const [invoiceRadio, setInvoiceRadio] = useState<string>("YES");
  const [
    schneiderCreateInvoicePopupOpen,
    setSchneiderCreateIncoicePopupOpen
  ] = useState<boolean>(false);
  const storeData = store.getState();
  const session = storeData && storeData.App && storeData.App.session;
  const sessionId = getSessionId(session.uuid);
  const myLoadsMaxPageSize = FetchFromMyLoadConfig("PageSize");
  const shipmentDetails: IEShipmentResponse = useSelector(getShipmentDetails());
  const shipmentCostItems: IEShipmentCostItem[] = shipmentDetails?.shipments
                            && shipmentDetails?.shipments?.length > 0 
                            ? shipmentDetails?.shipments[0]?.shipmentCostItems : [];
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [contactDetails, setContactDetails] = useState<any>(null);
  const SubmitInvoiceModalProps = {
    isModalOpen: isInvoiceModalOpen,
    title: t("Submit Invoice"),
    size: "large large_width large_height",
    contentScroll: "allow",
    aditionalCssClass: "invoice-modal",
    buttons: [
      {
        title: t("Cancel"),
        type: "secondary-cta-btn-mobile",
        onClick: () => {
          setIsInvoiceModalOpen(false);
          setInvoiceRadio("YES");
        }
      },
      {
        title: t("Submit"),
        type: "primary-cta-btn-mobile",
        onClick: () => {
          handleInvoiceSubmission();
        }
      }
    ]
  };
  const declineLoadModalProps =
  {
 isModalOpen : showModalforDeclineLoad,
 title: declined_load_modal_title,
 message_header: declined_load_modal_message,
 aditionalCssClass:"decline-load",
   size: declineReasonDropDownVisibility(props?.load?.sourceTMS,props?.load?.division,REASON_CODES)?"medium_declineLoad":"medium_acceptload",
   buttons: [
     {
       title: i18n.t('No'),
       type: "secondary-cta-btn-web",
       onClick: () => {          
         setShowModalforDeclineLoad(false)
         setDeclineReasonCode("")
         setPayloadReasonCode("")
       }
     },
     {
       title: i18n.t('Decline'),
       type: "primary-cta-btn-web",
       isDisabled: declineReasonDropDownVisibility(props?.load?.sourceTMS,props?.load?.division,REASON_CODES)? (declineReasonCode === "" || declineReasonCode === null || declineReasonCode === undefined) ? true :false:false,
       onClick: () => {               
        const getShipmentmodel: GetShipment = new GetShipment();
        const module = props?.load?.module;
        getShipmentmodel.shipmentIds = props?.load?.shipmentId;
        dispatch(
          buyLoadShipmentRequest(
            {
              query: getShipmentmodel.getRequestShipmentPayload(),
              shipmentId: props?.load?.shipmentId,
              module,
              isPullToRefresh: false,
              isGlobalSearch : props?.load?.history?.location?.state?.isGlobalSearch
            },
           (res : any)=>
           {
            const _shipmentData = res?.getShipment?.length > 0 && res?.getShipment[0];
            if(_shipmentData)
            {
          const _model: any = new TenderAction();
_model.shipmentId = props.load && props.load.shipmentId;
_model.sourceSystem = props.load && props.load.sourceTMS;
_model.eventDateTime = getCurrentDatewithTimeZone(props.load && props.load.loadStop);
_model.customer = getCustomer(_shipmentData && _shipmentData?.shipmentInvolvedParties);
_model.assignmentStatus = props.load && props.load.assignmentStatus;
_model.actionType = DECLINE_ACTION_TYPE;
_model.actionQualifier = DECLINE_ACTION_QUALIFIER;
_model.actionDetail = payloadReasonCode;
_model.shipmentState = props.load && props.load.shipmentState || null;
_model.actionDateTime = null;
_model.offeredRate = (props?.load?.shipmentTenderedCarriers && props?.load?.shipmentTenderedCarriers[0]?.offeredRate ? ( props?.load?.shipmentTenderedCarriers[0]?.offeredRate === 0 || props?.load?.shipmentTenderedCarriers[0]?.offeredRate === null)? null : props?.load?.shipmentTenderedCarriers[0]?.offeredRate : null )
dispatch(tenderAction(_model.getTenderActionPayload(),false,(response: any) => {
if (response.message === DECLINE_ACTION_TYPE) {
  setShowModalforDeclineLoad(false)
  setDeclineReasonCode("")
  setPayloadReasonCode("")
  ToastMessage.showWeb(TENDER_DECLINE_SUCCESS_MESSAGE);
  updatedCarrierTenderedShipments()
}
else
{
  ToastMessage.showWeb(response.message);
  setShowModalforDeclineLoad(false);
  setDeclineReasonCode("")
  setPayloadReasonCode("")
  const carrierModel:  MyLoad = new MyLoad();
  carrierModel.filter = { carrierTendered: true };
  carrierModel.pagination = {
    pageSize: myLoadsMaxPageSize,
    pageIndex: 0,
  };
  dispatch(fetchShipments(carrierModel.getCarrierTenderedShipments(), false));
}
}));
            }
          }))
        }
      }
   ]
}
const updatedLoadDetails =() =>
{
  const getShipmentmodel: GetShipment = new GetShipment();
  const module = props?.module;
  getShipmentmodel.shipmentIds = props?.load?.shipmentId;
  dispatch(
    buyLoadShipmentRequest(
      {
        query: getShipmentmodel.getRequestShipmentPayload(),
        shipmentId:props?.load?.shipmentId,
        module,
        isPullToRefresh: false,
        isGlobalSearch : props?.history?.location?.state?.isGlobalSearch
      },
     (res : any)=>
     {
       const _shipmentData = res?.getShipment?.length > 0 && res?.getShipment[0];
       if(_shipmentData)
       {
        setIsInvoiceModalOpen(true);
       }
     }))
}
  const updatedCarrierTenderedShipments = () => {
    const updated: MyLoad = new MyLoad()
    const _input: any = {
      carrierAssigned: true,
      carrierTendered: true,
      driverAssigned: true,
      inTransit: true,
      deliveredNeedsPaperWork: true,
      deliveredWithPaperWork: true,
    }
    updated.pagination = {
      pageSize: IONICWrapper?.details?.keys?.configuration?.MyLoadsConfig.PageSize.Web || myLoadsMaxPageSize || MyLoadsConfigFallback.PageSize.Web,
      pageIndex:0 ,
      //myLoadPageFilter: null
    }
    updated.filter = _input;
    dispatch(fetchShipments(updated.getCarrierTenderedShipments(), false))
  }
  const handleFileChange = (event: any) => {
    const fileObj = event.target.files;
    let result: any[] = [];
    if (fileObj.length > 0) {
      let temp = [...uploadedDocuments];
      if (temp.length === 0) {
        [...fileObj].forEach((item: any, index: number) => {
          if (validateDocumentContent(item)) {
            result.push({ rank: index + 1, content: item });
          }
        });
      } else {
        result = [...temp];
        [...fileObj].forEach((item: any, index: number) => {
          if (validateDocumentContent(item)) {
            result.push({ rank: temp.length + (index + 1), content: item });
          }
        });
      }
      setUploadedDocuments(result);
    }
  };
  const [invoiceID, setInvoiceID] = useState("");
  const uploadInvoiceProps = {
    uploadedDocuments: uploadedDocuments,
    selectedUploadDocumentType: null,
    handleFileChange: handleFileChange,
    updateUploadedDocuments: (item: any[]) => setUploadedDocuments(item),
    executionStarted: true,
    invoiceID: props.carrierPro ? props.carrierPro : invoiceID,
    handleInvoiceIdChange: (e: any) => setInvoiceID(e?.target?.value),
    ppkWrkPage: isInvoiceModalOpen,
    carrierProID: invoiceID,
    sourceTMS:props?.sourceTMS,
    division:props?.division
  };
  const createInvoiceSuccess = {
    isModalOpen: schneiderCreateInvoicePopupOpen,
    title: t("Thank You"),
    contentAlignment: "left",
    size: "small extra_small_height",
    contentScroll: "allow",
    message_content: `Schneider will prepare the invoice on your behalf.
      Email sent to your registered email address.`,
    buttons: [
      {
        title: t("Ok"),
        type: "primary-cta-btn-web",
        onClick: () => {
          setSchneiderCreateIncoicePopupOpen(false);
          fetchLoad();
        }
      }
    ]
  };
  const handleInvoiceSubmission = async () => {
    if (invoiceRadio === "YES") {
      if (uploadedDocuments.length > 0) {
        let content: any[] = [];
        uploadedDocuments.forEach(async (item: any) => {
          content.push(await toBase64(item.content));
        });
        let payload:any = payloadCreationForDocUpload({
          shipmentId: getPayLoadShipmentId(props),
          sourceSystem: getSourceSystemDetails(props),
          division:  props?.division || "",
          documents: uploadedDocuments,
          invoiceNumber: invoiceID || ""
        });
        const callback = (responseType: string, data: any) => {
          if (responseType === "success") {
            setUploadedDocuments([]);
            setIsInvoiceModalOpen(false);
            setInvoiceRadio("YES");
            setInvoiceID("");
            data && data.message && isMobile
              ? ToastMessage.show(data.message)
              : ToastMessage.showWeb(data.message);
            fetchLoad();
            logEvent(EVENT.UE_INVOICE_UPLOAD_SUCCESS, {
              screen: SCREEN.MYLOADS_DELIVERED_WITH_PPWK,
              carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
                props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.carrierId,
              shipmentId: getPayLoadShipmentId(props),
            });
          } else if (responseType === "failed") {
            logEvent(EVENT.UE_INVOICE_UPLOAD_FAILURE, {
              screen: SCREEN.MYLOADS_DELIVERED_WITH_PPWK,
              carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
                props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.carrierId,
              shipmentId: getPayLoadShipmentId(props),
            });
          }
        };
        dispatch(
          submitInvoiceNew({
            query: payload,
            callback,
            type: SUBMIT_INVOICE
          })
        );
      } else {
        ToastMessage.showWeb(
          MYLOAD_DOCUMENT_UPLOAD.ADD_DOCUMENT_CONFIG.mobileUploadFooterContent
        );
      }
    } else {
      let payload:any = {
        sendEmail: true,
        shipmentId: getPayLoadShipmentId(props),
        invoiceNumber: invoiceID ? invoiceID : props?.carrierPro 
      };
      const InvoiceModel = new UploadDocumentModel();
      const callback = async (responseType: string, data: any) => {
        await setInvoiceID("");
        await setIsInvoiceModalOpen(false);
        await setInvoiceRadio("YES");
        if (responseType === "success") {
          setSchneiderCreateIncoicePopupOpen(true);
          logEvent(EVENT.UE_INVOICE_GENERATION_SUCCESS, {
            screen: SCREEN.MYLOADS_DELIVERED_WITH_PPWK,
            carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
              props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.carrierId,
            shipmentId: getPayLoadShipmentId(props),
          });
        } else if (responseType === "failed") {
          data && data.message && isMobile
            ? ToastMessage.show(data.message)
            : ToastMessage.showWeb(data.message);
          logEvent(EVENT.UE_INVOICE_GENERATION_FAILURE, {
            screen: SCREEN.MYLOADS_DELIVERED_WITH_PPWK,
            carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
              props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.carrierId,
            shipmentId: getPayLoadShipmentId(props),
          });
        }
      };
      await dispatch(
        createInvoice({
          query: InvoiceModel.createInvoice(payload),
          callback,
          type: CREATE_INVOICE
        })
      );
    }
  };
  const fetchLoad = () => {
    if (props.assignmentStatus) {
      const searchLoadByIdModal = new SearchById();
      const userRole = getFormatRoles();
      searchLoadByIdModal.userId = props.userDetails?.memberDetailsResponse?.member?.upn;
      searchLoadByIdModal.carrierId = props.userDetails?.memberDetailsResponse?.member?.carrierId;
      searchLoadByIdModal.page = 0;
      searchLoadByIdModal.carrierScac =
        (props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.carrierInfo && props.userDetails.memberDetailsResponse.carrierInfo.carrierScac) || "";
      searchLoadByIdModal.carrierTier =
        (props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.carrierInfo && props.userDetails.memberDetailsResponse.carrierInfo.carrierTier) || "";
      searchLoadByIdModal.managedEquipmentCapability =
        (props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.carrierInfo && props.userDetails.memberDetailsResponse.carrierInfo.managedEquipmentCapability) ||
        null;
      searchLoadByIdModal.nonManagedEquipmentCapability =
        (props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.carrierInfo && props.userDetails.memberDetailsResponse.carrierInfo.nonManagedEquipmentCapability) ||
        null;
      searchLoadByIdModal.userRole = userRole.join(",");
      searchLoadByIdModal.loadNumberAlias = props.load.shipmentId;
      props.searchByReferenceId(searchLoadByIdModal.getRequestPayload(), false, () => {
        props.showMap && props.expandMap && props.expandMap(false);
      });
    } else {
      const userPrincipalName: string =
        (props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.upn) || "";
      if (userPrincipalName) {
        const isDriver = !isEntitled("myLoad", "carrierAssigned");
        const _model: MyLoad = new MyLoad();
        if (isDriver) {
          _model.driverId = userPrincipalName;
        }
        _model.filter = {
          carrierAssigned: true,
          driverAssigned: true,
          carrierTendered: true,
          inTransit: true,
          deliveredNeedsPaperWork: true,
          deliveredWithPaperWork: true
        };
        _model.pagination={
          pageSize: IONICWrapper?.details?.keys?.configuration?.MyLoadsConfig.PageSize.Web || myLoadsMaxPageSize || MyLoadsConfigFallback.PageSize.Web,
          pageIndex:0 ,
          //myLoadPageFilter: null
        }
        props.fetchMyloads(_model.getDeliveredWithPPWKShipments());
      }
    }
    setInvoiceRadio("YES");
  };
  const handleSubmitInvoiceClick = () => {
    if (props.load && props.load.managedEquipment) {
      if (notValidTrailer(props.load && props.load.loadStop)) {
        setinvoiceValidationModal({
          isModalOpen: true,
          title: (IONICWrapper.details.keys && IONICWrapper.details.keys.configuration.invoice_validation_modal_title) || invoice_validation_modal_title,
          message_content: (IONICWrapper.details.keys && IONICWrapper.details.keys.configuration.invoice_validation_modal_message) || invoice_validation_modal_message,
          size: "extra_small_height",
          contentScroll: "deny",
          buttons: [
            {
              title: t("Ok"),
              type: "primary-cta-btn-web",
              onClick: () => {
                setinvoiceValidationModal({
                  isModalOpen: false
                });
                props.getShipmentDetails(() => {
                  const __nav: { [key: string]: string } = {};
                  __nav[MY_LOAD] = `/app/myLoad/Execution/${getPayLoadShipmentId(props)}`;
                  dispatch(setNavigation(__nav));
                  props.history.push(`/app/myLoad/Execution/${getPayLoadShipmentId(props)}`, {
                    module: props.module,
                  });
                })
                logEvent(EVENT.UE_INVOICE_TRAILER_CONFIRMED, {
                  screen: SCREEN.MYLOADS_DELIVERED_WITH_PPWK,
                  carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
                    props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.carrierId,
                  shipmentId: getPayLoadShipmentId(props),
                });
              }
            }
          ]
        });
        logEvent(EVENT.SV_INVOICE_TRAILER_CONFIRMATION, {
          screen: SCREEN.MYLOADS_DELIVERED_WITH_PPWK,
          carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
            props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.carrierId,
          shipmentId: getPayLoadShipmentId(props),
        });
      } else {
        updatedLoadDetails();          
        logEvent(EVENT.SV_INVOICE_CHOICE, {
          screen: SCREEN.MYLOADS_DELIVERED_WITH_PPWK,
          carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
            props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.carrierId,
          shipmentId: getPayLoadShipmentId(props),
        });
      }
    } else {
      updatedLoadDetails();
      logEvent(EVENT.SV_INVOICE_CHOICE, {
        screen: SCREEN.MYLOADS_DELIVERED_WITH_PPWK,
        carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.carrierId,
        shipmentId: getPayLoadShipmentId(props),
      });
    }
  };
  const paymentStatusLink =
    (IONICWrapper.details.keys &&
      IONICWrapper.details.keys.configuration &&
      IONICWrapper.details.keys.configuration.webPaymentLink) ||
    WEB_PAYMENT_LINK;
  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0
  });

  const colorCode =
    IONICWrapper.details.getKeyValuePairs("booknow_color") ||
    DEFAULT_BUTTON_COLOR;
  const dispatch = useDispatch();
  const getActionName = (): string => {
    let name: string = "";
    if (props.module == MODULES.CARRIER_ASSIGNED_MODULE){
      name = ASSIGN_DRIVER_CTA_TEXT;
    } else if (props.module == MODULES.CARRIER_TENDERED_MODULE) {
      if (loadTileButtonVisibility(props?.sourceTMS, props?.division, "Accept")) name = "Accept Load";
      else name = CONTACT_US_TEXT;
    } else if (props.module == MODULES.DRIVER_ASSIGNED_MODULE) {
      if (props.isTripStarted) {
        name = "Update";
      } else {
        name = "Start Trip";
      }
    } else if (props.module == MODULES.INTRANSIT_MODULE) {
      name = "Update";
    } else if (
      props.module == MODULES.DELIVERED_WITH_PPWK_MODULE ||
      props.module == MODULES.RECENTLY_DELIVERED_MODULE
    ) {
      name = "See Details";
    } else if (props.rate && props.rate.totalCharge && props.buyAllowed) {
      if(updateduserDetails &&   updateduserDetails.memberDetailsResponse &&  updateduserDetails.memberDetailsResponse.carrierInfo &&   updateduserDetails.memberDetailsResponse.carrierInfo.carrierActiveIndicator === false)
      {
      name = IONICWrapper.details.getKeyValuePairs("get_qualified_button_title") || GET_QUALIFIED_BUTTON_NAME;
      }
      else{
        name = "Book Now";
      }
    } else {
      if(updateduserDetails && updateduserDetails.memberDetailsResponse &&  updateduserDetails.memberDetailsResponse.carrierInfo &&
          updateduserDetails.memberDetailsResponse.carrierInfo.carrierActiveIndicator === false 
          && updateduserDetails.memberDetailsResponse.carrierInfo.source !== "ASL"
         )
      {
      name = IONICWrapper.details.getKeyValuePairs("get_qualified_button_title") || GET_QUALIFIED_BUTTON_NAME;
      }
      else{
      name = "Contact to Book";
      }
    }
    return name;
  };
  const getLatestTransaction = (assignmentTransaction: any) => {
    var selectedTransaction: number = 0;
    var latestTransaction: number = parseInt(
      assignmentTransaction[0].transactionId
    );
    for (let index = 0; index < assignmentTransaction.length; index++) {
      var transition = parseInt(assignmentTransaction[index].transactionId);
      if (transition > latestTransaction) {
        latestTransaction = transition;
        selectedTransaction = index;
      }
    }
    return selectedTransaction;
  };
  const isDriverAssigned = (load: any) => {
    return load
      ? load.assignmentTransaction && load.assignmentTransaction.length
        ? load.assignmentTransaction[
            getLatestTransaction(load.assignmentTransaction)
          ].transactionType === ASSIGN_DRIVER_CTA_TEXT
        : load.driverAssignmentStatus
      : false;
  };
  useEffect(() => {
    if (
      IONICWrapper.details.auth.user.roles.includes(Roles.carrierDispatcher)
    ) {
      const isAssigned: Boolean = isDriverAssigned(load);
      switch (props.module) {
        case MODULES.CARRIER_TENDERED_MODULE:
          if(loadTileButtonVisibility(props?.sourceTMS,props?.division,"Decline")){
            setShowButton(true);
            setButtonName("Decline Load");
          } else{
            setShowButton(false);
            setButtonName("");
          }
          break;
        case MODULES.CARRIER_ASSIGNED_MODULE:
          setShowButton(load.executionStatus === EXECUTIONSTATUS.STARTED);
          setButtonName("Update");
          break;
        case MODULES.RECENTLY_DELIVERED_MODULE:
          setShowButton(false);
          break;
        case MODULES.DRIVER_ASSIGNED_MODULE:
          setShowButton(true);
          setButtonName(props?.isManageUserAssignedLoad ? VIEW_LOAD_CTA_TEXT : UN_ASSIGN_DRIVER_CTA_TEXT);
          break;
        case MODULES.INTRANSIT_MODULE:
          setShowButton(true);
          setButtonName(
            isAssigned ? UN_ASSIGN_DRIVER_CTA_TEXT : ASSIGN_DRIVER_CTA_TEXT
          );
          break;
      }
    } else {
      setShowButton(false);
    }
  }, [load, props.module]);

  const handlePaymentStatusLink = () => {
    window && window.open(paymentStatusLink, "_blank");
    const shipmentId = (props.load && props.load.shipmentId) || "";
    const carrierId = (props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId) || "";
    const roles =
      (props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.userApplicationDetails[0] &&
        props.userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles) ||
      [];
    logEvent(EVENT.UE_PAYMENT_STATUS_REDIRECT, {
      screen: SCREEN.DELIVERED_SHIPMENT_DETAILS,
      carrierId,
      shipmentId,
      roles
    });
  };

  const searchByLoadId = () => {
    const searchLoadByIdModal = new SearchById();
    const userRole = getFormatRoles();
    searchLoadByIdModal.userId = updateduserDetails?.memberDetailsResponse?.member?.upn;
    searchLoadByIdModal.carrierId = updateduserDetails?.memberDetailsResponse?.member?.carrierId;
    searchLoadByIdModal.page = 0;
    searchLoadByIdModal.carrierScac =
      (updateduserDetails?.memberDetailsResponse?.carrierInfo?.carrierScac) || "";
    searchLoadByIdModal.carrierTier =
      (updateduserDetails?.memberDetailsResponse?.carrierInfo?.carrierTier) || "";
    searchLoadByIdModal.managedEquipmentCapability =
      (updateduserDetails?.memberDetailsResponse?.carrierInfo?.managedEquipmentCapability) ||
      null;
    searchLoadByIdModal.nonManagedEquipmentCapability =
      (updateduserDetails?.memberDetailsResponse?.carrierInfo?.nonManagedEquipmentCapability) ||
      null;
    searchLoadByIdModal.userRole = userRole.join(",");
    searchLoadByIdModal.loadNumberAlias = props?.shipmentId;
    const _model: MyLoad = new MyLoad();
    _model.filter = {
      driverAssigned: true,
    };
    _model.pagination = {
      pageSize: myLoadsMaxPageSize,
      pageIndex: 0,
    }
    props.fetchShipmentsManageUser(_model.getMyLoadCount(), false, (res: any) => {
      props.searchByReferenceIdManageUser(
        searchLoadByIdModal.getRequestPayload(),
        false, () => {
          const getShipmentmodel: GetShipment = new GetShipment();
          const module = props?.module;
          getShipmentmodel.shipmentIds = props?.load?.shipmentId;
          dispatch(
            buyLoadShipmentRequest(
              {
                query: getShipmentmodel.getRequestShipmentPayload(),
                shipmentId: props?.load?.shipmentId,
                module,
                isPullToRefresh: false,
                isGlobalSearch: true
              },
              (res: any) => {
                const _shipmentData = res?.getShipment?.length > 0 && res?.getShipment[0];
                if (_shipmentData) {
                  updateHistoryProps();
                }
              }))
        })
    })
  };
  const updateHistoryProps = () =>
    {
      history.push({state :{
        shipments: props?.load,
        module: props?.module,
        isGlobalSearch: true,
        shipmentId:props?.shipmentId,
        isManageUserViewLoad: true
      }});
    } 
 
  const getLoadDetails = (shipmentToStartTrip: any): any => {
    return shipmentToStartTrip || {};
  };
  const handleDeclineReasonCodeChange = (event: any) => {
    const { value, name } = event.target;
    setDeclineReasonCode(value);
    setPayloadReasonCode(name);
  };
  const loadStopModel = new LoadStopModel();
  return (
    <>
    {isContactModalOpen &&   <ContactUsModal
        isOpen={isContactModalOpen}
        onClosed={() => setIsContactModalOpen(false)}
        contactDetails={contactDetails}/>}
      {!props.isMyload && props.module !==MODULES.CARRIER_TENDERED_MODULE &&
        !(
          props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&
          props.userDetails.memberDetailsResponse.member.userApplicationDetails &&
          props.userDetails.memberDetailsResponse.member.userApplicationDetails.length > 1 &&
          props.userDetails.memberDetailsResponse.member
            .userApplicationDetails[0].roles &&
          props.userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles.find(
            (item: any) => item.roleName === "carrierGuest"
          )
        ) && (
          <div
            className="watch-section"
            onClick={() => toggleWatchLoad(loadId, load, isWatched)}
          >
            <IonImg
              src={`assets/icon/${
                isWatched ? "watched-desktop" : "watch-icon"
              }.svg`}
              className="watchedLoad-icon"
            />
            <p className="unwatch-p">{isWatched ? "Unwatch" : "Watch"}</p>
          </div>
        )}
      {!props.isMyload && props.rate && props.rate.totalCharge ? (
        <p className="card-price" dat-test="card-price">
          {currencyFormatter.format(Math.trunc(props.rate.totalCharge))}
        </p>
      ) : (
        !props.isMyload && props.module !==MODULES.CARRIER_TENDERED_MODULE && <div className="empty_div"></div>
      )}
      {showButton && (
        <IonButton
          className={`secondary-cta-btn-web load-tile-right-btn ${props?.isManageUserAssignedLoad?'view-assigned-load':''}`}
          onClick={() => {
            if(props.module ===MODULES.CARRIER_TENDERED_MODULE){
            logEvent(EVENT.CARRIER_TENDERED_DECLINE, {
              screen:SCREEN.CARRIER_TENDERED,
              shipmentId: props.load && props.load.shipmentId,
              sessionId :sessionId
            })
            setShowModalforDeclineLoad(true)
           }
           else if(props?.isManageUserAssignedLoad)
           {
            searchByLoadId();
           }
           else props.driverAction(buttonName);
          }}
        >
          {" "}
          {buttonName}
        </IonButton>
      )}
      {props.isMyload &&
      loadStopModel.isTripCompleted(getLoadDetails(props)) &&
      props.module === MODULES.DELIVERED_WITH_PPWK_MODULE ? (
        props.invoiceCreatedDateTime ? (
          <>
            {SourceTMSValidation(
              (props && props.sourceTMS) || "",
              (props && props.division) || "",
              ESOURCE_TYPE_CHECK.PAYMENT_STATUS_BUTTON_ROLE
            ) && (
              <IonButton
                className="secondary-cta-btn-web load-tile-right-btn payment-btn"
                data-testid={"payment-status"}
                onClick={handlePaymentStatusLink}
              >
                {i18n.t("CHECK_PAYMENT_STATUS_CTA_TEXT")}
              </IonButton>
            )}
          </>
        ) : (
          <>
            {SourceTMSValidation(
              (props && props.sourceTMS) || "",
              (props && props.division) || "",
              ESOURCE_TYPE_CHECK.INVOICE_UPLOAD_DOCUMENT_ROLE
            ) && (
              <IonButton
                className="secondary-cta-btn-web load-tile-right-btn payment-btn"
                data-test={"payment-status"}
                onClick={handleSubmitInvoiceClick}
              >
                {"Submit Invoice"}
              </IonButton>
            )}
          </>
        )
      ) : (
        props.module === MODULES.RECENTLY_DELIVERED_MODULE &&
        SourceTMSValidation(
          (props && props.sourceTMS) || "",
          (props && props.division) || "",
          ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_ROLE
        ) && (
          <IonButton
            className="secondary-cta-btn-web load-tile-right-btn payment-btn"
            data-testid={"SUBMIT_REQUIRED_PPWK_TEXT"}
            onClick={() => props.expandMap && props.expandMap(true)}
          >
            {i18n.t("SUBMIT_REQUIRED_PPWK_TEXT")}
          </IonButton>
        )
      )}
      {props.isMyload && props.module == MODULES.RECENTLY_DELIVERED_MODULE && (
        <div className="delivered-details">
          Delivered On:{" "}
          <span className="delivered-date">{props.deleveredOn}</span>
        </div>
      )}
      {getActionName() ? !props?.isManageUserAssignedLoad && <CustomButton
        className="primary-cta-btn-web load-tile-right-btn primary "
        data-test={`${getActionName()}_${colorCode}` || ""}
        onClick={() => {
          if (props?.isMyload && props?.module === MODULES?.CARRIER_TENDERED_MODULE) {
            if (loadTileButtonVisibility(props?.sourceTMS, props?.division, "Accept")) {
              props.onActionClick(isClicked, () => {
                setOnClick(true);
              });
            } else {
              const callback = (responseType: string, data: any) => {
                if (responseType === "success") {
                 setIsContactModalOpen(true)
                 setContactDetails(data?.message)
                } else {
                 ToastMessage.showWeb(CONTACT_DETAILS_NOT_FOUND);
               }
               };
               const payload = props?.load?.shipmentId;
               dispatch(contactUsDetailsRequest({
                 query: payload,
                 callback
               }))
 
            }
          } else if (props?.isMyload) {
            props.onActionClick(isClicked, () => {
              setOnClick(true);
            });
          }else {
            props.buyLoadModal(
              props.load.loadId,
              props,
              props.load.sourceSystem
            );
          }
        }}
      >
        {getActionName()}
      </CustomButton>
      : <div className="empty_div"></div>
}
      <CustomModalWeb {...invoiceValidationModal} />
      <CustomModalWeb {...createInvoiceSuccess} />
      <CustomModalWeb {...declineLoadModalProps}>
      { declineReasonDropDownVisibility(props?.load?.sourceTMS,props?.load?.division,REASON_CODES)  && 
        <div className="decline-data">
        <div className="decline-reason-labelname">Decline Reason Code</div>
          <DeclineDropDown
            sourceTMS={props?.sourceTMS}
            division={props?.division}
            labelName="Enter Decline Reason Code"
            declineReason={declineReasonCode}
            payloadReasonCode={payloadReasonCode}
            handleChange={handleDeclineReasonCodeChange}
          />
        </div>
      }
      </CustomModalWeb>
      <CustomModalWeb {...SubmitInvoiceModalProps}>
        {
          SourceTMSValidation(
            (props?.sourceTMS) || "",
            (props?.division) || "",
            ESOURCE_TYPE_CHECK.SCHNEIDER_INVOICE_CREATION_SECTION_ROLE
          ) &&
            (props?.userDetails?.memberDetailsResponse?.carrierSettings?.carrierInvoiceExists) &&
          <InvoiceRadioContainer
          radioButtonData={radioButtonData}
          handleChange={(e: any) => {
            setInvoiceRadio(e?.target?.value);
            setInvoiceID("");
            if(e?.target?.value === "NO" && uploadedDocuments?.length > 0 ){
              setUploadedDocuments([])
            }
          }}
          invoiceRadio={invoiceRadio}
          sourceTMS={props?.sourceTMS}
        />
        }
          <div className="documents-component">
            {invoiceRadio !== "YES" && isCarrierProVisible(props?.sourceTMS, props?.division) && <p className="upload-document-invoiceNumber-label">{`${ENTER_INVOICE_ID_HEADER}/${CARRIER_PRO_ID_HEADER}`}</p>}
            {(invoiceRadio === "NO" && !isInvoiceInputFieldVisible(props?.sourceTMS, props?.division)) ? null : <UploadDocument {...uploadInvoiceProps} invoiceRadio={invoiceRadio} />}
          </div>
        <div className="documents-component">
          <IonCard className="SubmitInvoiceCard">
            <IonCardHeader className="start-trip-invoiceCardContent">
              {t("Rate Details")}
            </IonCardHeader>
            <IonCardContent className="book-card-content">
              <div className="book-load-cardContent">
                <IonRow className="content-row heading">
                  <IonCol
                    className="reference-type-header book-header"
                    size="3"
                    offset="0.25"
                  >
                    {t("CHARGE_DESCRIPTION")}
                  </IonCol>
                  <IonCol
                    className="reference-type-header book-load-col2 book-header"
                    size="8.75"
                  >
                    <IonRow>
                      <IonCol size="6.1" className="book-load-col3 ">
                        {t("RATE_QUALIFIER")}
                      </IonCol>
                      <IonCol size="2.6" className="book-load-col3 ">
                        {t("BOOLOAD_QTY")}
                      </IonCol>
                      <IonCol size="3" className="book-load-col">
                        {t("Total")}
                      </IonCol>
                    </IonRow>
                  </IonCol>
                  <IonItemDivider />
                </IonRow>
                <>
                  {shipmentCostItems.map(
                      (shipmentCostItems: any, index: number) => (
                        <IonRow key={index} className="document-table-row">
                          <IonCol
                            className="document-val"
                            size="4"
                            offset="0.25"
                          >
                            <IonRow>
                              <IonLabel>
                                {shipmentCostItems.costBreakdownDescription}
                              </IonLabel>
                            </IonRow>
                          </IonCol>
                          <IonCol
                            className="document-val"
                            size="3.25"
                            offset="0.5"
                          >
                            <IonRow>
                              <IonLabel>
                                {shipmentCostItems.costBreakdownRate}
                                {"/"}
                                {shipmentCostItems.costBreakdownRateQlfr}
                              </IonLabel>
                            </IonRow>
                          </IonCol>
                          <IonCol
                            className="document-val"
                            size="1"
                            offset="0.5"
                          >
                            <IonRow>
                              <IonLabel>
                                {shipmentCostItems.costBreakdownQty}
                              </IonLabel>
                            </IonRow>
                          </IonCol>
                          <IonCol
                            className="document-val"
                            size="1.5"
                            offset="1"
                          >
                            <IonRow>
                              <IonLabel>
                                {" "}
                                {currencyFormatterRate.format(
                                  shipmentCostItems.costBreakdownTotalAmount ||
                                    0
                                )}
                              </IonLabel>
                            </IonRow>
                          </IonCol>
                          {index < shipmentCostItems.length - 1 && (
                            <IonItemDivider />
                          )}
                        </IonRow>
                      )
                    )}
                </>
                <IonItemDivider />
                <IonRow className="book-load-row">
                  <IonCol offset="0.25" size="6">
                    Total
                  </IonCol>
                  <IonCol className="Total-count" size="4.15" offset="1.6">
                    {currencyFormatterRate.format(
                      (props.load && props.load.totalCostAmount) || 0
                    )}
                  </IonCol>
                </IonRow>
              </div>
            </IonCardContent>
          </IonCard>
        </div>
        <div className="submit-invoice-message">{SUBMIT_INVOICE_MESSAGE}</div>
      </CustomModalWeb>
    </>
  );
};

export default LoadTileRight;
